export type TitleChangeHandler = (title: string) => void;

export class ContentTypeTitleService {
	private titleChangeHandler: TitleChangeHandler;

	constructor() {
		this.titleChangeHandler = () => {};
	}

	updateTitle(title: string) {
		this.titleChangeHandler(title);
	}

	setTitleChangeHandler(cb: TitleChangeHandler) {
		this.titleChangeHandler = cb;
	}
}

export const contentTypesTitleServiceSingleton = new ContentTypeTitleService();
